// routes
import { PATH_DASHBOARD } from "src/routes/paths";
// components
import Label from "src/components/Label";
import Iconify from "src/components/Iconify";
import SvgIconStyle from "src/components/SvgIconStyle";
import styled from "@emotion/styled";
// ----------------------------------------------------------------------

const getIcon = (name) => <SvgIconStyle src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const IconStyle = styled(Iconify)(({ theme }) => ({
  width: 20,
  height: 20,
  marginTop: 1,
  flexShrink: 0,
  marginRight: theme.spacing(2),
}));

const ICONS = {
  blog: getIcon("ic_blog"),
  users: getIcon("fa6-solid:users"),
  cart: getIcon("ic_cart"),
  chat: getIcon("ic_chat"),
  mail: getIcon("ic_mail"),
  user: getIcon("ic_user"),
  users: getIcon("ic_users"),
  contacts: getIcon("ic_contacts"),
  agreement: getIcon("ic_agreement"),
  kanban: getIcon("ic_kanban"),
  banking: getIcon("ic_banking"),
  booking: getIcon("ic_booking"),
  invoice: getIcon("ic_invoice"),
  calendar: getIcon("ic_calendar"),
  ecommerce: getIcon("ic_ecommerce"),
  analytics: getIcon("ic_analytics"),
  dashboard: getIcon("ic_dashboard"),
  menuItem: getIcon("ic_menu_item"),
};

const navConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: "general",
    items: [
      {
        title: "Dashboard",
        path: PATH_DASHBOARD.general.app,
        icon: ICONS.dashboard,
      },
    ],
  },

  // MANAGEMENT Applicant
  // ----------------------------------------------------------------------
  {
    subheader: "Management",
    role: "applicant",
    items: [
      // USER
      {
        title: "MyAccount",
        path: PATH_DASHBOARD.user.account,
        icon: <IconStyle icon={"codicon:account"} />,
      },

      {
        title: "AssessmentForm",
        path: PATH_DASHBOARD.user.assessment,
        icon: <IconStyle icon={"ic:outline-assessment"} />,
      },
      {
        title: "Consultants",
        path: PATH_DASHBOARD.user.cards,
        icon: <IconStyle icon={"fa6-solid:users"} />,
      },
    ],
  },
  {
    subheader: "Questioner",
    role: "applicant",
    items: [
      {
        title: "Applicant",
        icon: <IconStyle icon={"codicon:account"} />,
        children: [
          {
            title: "General",
            path: PATH_DASHBOARD.user.applicant,
          },
          { title: "Background", path: PATH_DASHBOARD.user.applicantbg },
          // { title: "Documents", path: PATH_DASHBOARD.user.applicantdoc },
        ],
      },
      {
        title: "Spouse",
        icon: <IconStyle icon={"codicon:account"} />,
        children: [
          {
            title: "General",
            path: PATH_DASHBOARD.user.spouse,
          },
          { title: "Background", path: PATH_DASHBOARD.user.spousebg },
          // { title: "Documents", path: PATH_DASHBOARD.user.spousedoc },
        ],
      },
      {
        title: "FormerSpouse",
        icon: <IconStyle icon={"codicon:account"} />,
        children: [
          {
            title: "General",
            path: PATH_DASHBOARD.user.fspouse,
          },
          { title: "Background", path: PATH_DASHBOARD.user.fspousebg },
          // { title: "Documents", path: PATH_DASHBOARD.user.fspousedoc },
        ],
      },
      {
        title: "Children",
        path: PATH_DASHBOARD.user.children,
        icon: <IconStyle icon={"codicon:account"} />,
      },

      {
        title: "Documents",
        path: PATH_DASHBOARD.user.documents,
        icon: <IconStyle icon={"ion:documents-outline"} />,
      },
    ],
  }, // MANAGEMENT Consultant

  // ----------------------------------------------------------------------
  {
    subheader: "Management",
    role: "consultant",
    items: [
      // USER

      {
        title: "MyAccount",
        path: PATH_DASHBOARD.user.account,
        icon: <IconStyle icon={"codicon:account"} />,
      },

      // Profiles
      {
        title: "MyProfile",
        path: PATH_DASHBOARD.profile.root,
        icon: ICONS.user,
      },
      // SERVICE
      {
        title: "MyServices",
        path: PATH_DASHBOARD.service.root,
        icon: ICONS.ecommerce,
        children: [
          { title: "MyServices", path: PATH_DASHBOARD.service.services },
          { title: "CreateaService", path: PATH_DASHBOARD.service.new },
        ],
      },
      // BLOG
      {
        title: "MyBlog",
        path: PATH_DASHBOARD.blog.root,
        icon: ICONS.blog,
        children: [
          { title: "posts", path: PATH_DASHBOARD.blog.posts },
          { title: "CreateaPost", path: PATH_DASHBOARD.blog.new },
        ],
      },
    ],
  },
  {
    subheader: "CRM",
    role: "consultant",
    items: [
      {
        title: "Applicants",
        path: PATH_DASHBOARD.user.list,
        icon: ICONS.users,
      },
      {
        title: "Contacts",
        path: PATH_DASHBOARD.contact.root,
        icon: ICONS.contacts,
        children: [
          { title: "Contacts", path: PATH_DASHBOARD.contact.contacts },
          { title: "CreateaContact", path: PATH_DASHBOARD.contact.new },
        ],
      },
      {
        title: "invoices",
        path: PATH_DASHBOARD.invoice.root,
        icon: ICONS.invoice,
        children: [
          { title: "list", path: PATH_DASHBOARD.invoice.list },
          { title: "new", path: PATH_DASHBOARD.invoice.new },
        ],
      },
      {
        title: "Chat",
        path: PATH_DASHBOARD.chat.root,
        // path: "#",
        icon: ICONS.chat,
      },
    ],
  },
  {
    subheader: "coming soon...",
    role: "consultant",
    items: [
      {
        title: "Mail",
        path: PATH_DASHBOARD.mail.root,
        icon: ICONS.mail,
      },

      // {
      //   title: "Invoices",
      //   path: PATH_DASHBOARD.invoice.root,
      //   icon: ICONS.invoice,
      // },
      {
        title: "Agreements",
        // path: PATH_DASHBOARD.chat.root,
        path: "#",
        icon: ICONS.agreement,
      },
    ],
  },

  // APP
  // ----------------------------------------------------------------------
  // {
  //   subheader: "app",
  //   items: [
  //     {
  //       title: "mail",
  //       path: PATH_DASHBOARD.mail.root,
  //       icon: ICONS.mail,
  //       info: <Label color="error">+32</Label>,
  //     },
  //     // { title: "chat", path: PATH_DASHBOARD.chat.root, icon: ICONS.chat },
  //   ],
  // },
];

export default navConfig;
